import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import InnerImageZoom from "react-inner-image-zoom";

import "./GalleryStyle.css";

import { Mousewheel, Pagination } from "swiper";
import RoomHeader from "../RoomHeader";

import { FaRegImages } from "react-icons/fa";
import PlaceholderPreview from "./../../../../assets/images/Default_RoomDetail.jpg";

const Gallery = ({ selectedRoom }) => {
  const ImageURLPrepend =
    "https://famos.app.uni-regensburg.de/famosdaten/hoersaele/fotos/";

  const AddSwiperSlidesToDOM = (imgPaths, cName) => {
    let elements = [];
    for (let i = 0; i < imgPaths.length; i++) {
      elements.push(
        <SwiperSlide key={i}>
          <InnerImageZoom
            zoomType={undefined}
            zoomScale={1.2}
            className={"inner-img " + cName}
            src={
              imgPaths[i] !== PlaceholderPreview
                ? ImageURLPrepend + imgPaths[i]
                : PlaceholderPreview
            }
          />
        </SwiperSlide>
      );
    }
    return elements;
  };

  const loadFallback = () => {
    return AddSwiperSlidesToDOM([PlaceholderPreview], "default-prev");
  };

  return (
    <div className="gallery-container">
      <RoomHeader
        title="Bildergalerie"
        subtitle={selectedRoom.hoersaal}
        icon={<FaRegImages className="section-indocator-icon" />}
      />

      <div className="gallery-swiper-container">
        <Swiper
          className="gallery-swiper"
          direction={"vertical"}
          slidesPerView={1}
          spaceBetween={48}
          mousewheel={true}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          modules={[Mousewheel, Pagination]}
        >
          {/* Will load in the pictures as slides IF any picture exists AND no path is missing */}
          {selectedRoom.foto1 && selectedRoom.foto2
            ? AddSwiperSlidesToDOM([selectedRoom.foto1, selectedRoom.foto2], "")
            : loadFallback()}
        </Swiper>
      </div>
    </div>
  );
};

export default Gallery;
